<template>
  <div class="table_box">
    <el-table
      :summary-method="getSummaries"
      show-summary
      size="small"
      :data="data"
      border
      style="width:100%"
      :height="max"
      class="tabone_sty"
      @row-dblclick="rowdblclick"
      :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height: '40px'}"
    >
      <el-table-column width="40" align="center" prop="aaaa" fixed="left">
        <template slot="header" slot-scope="scope">
          <i class="el-icon-s-tools" style="color:#2594ff;font-size:18px" @click="clickIcon"></i>
        </template>
        <template slot-scope="scope">{{scope.$index +1 }}</template>
      </el-table-column>
      <el-table-column label="操作" prop="aaaa" align="center" width="80" fixed="left">
        <template slot-scope="scope">
          <el-button @click.native.prevent="addRow(scope.$index)" type="text" size="small">新增</el-button>
          <el-button @click.native.prevent="deleteRow(scope.$index)" type="text" size="small">移除</el-button>
        </template>
      </el-table-column>
      <template v-for="(item,index) in ConfigData">
        <!-- <el-table-column v-if="item.Name == '商品名称'" width="40" align="center" prop="aaaa" :key="'a'+index" fixed="left">
          <template slot="header" slot-scope="scope">
            <i class="el-icon-s-tools" style="color:#2594ff;font-size:18px" @click="clickIcon"></i>
          </template>
          <template slot-scope="scope">{{scope.$index +1 }}</template>
        </el-table-column>
        <el-table-column v-if="item.Name == '商品名称'" label="操作" prop="aaaa" align="center" width="80" :key="'b'+index" fixed="left">
        <template slot-scope="scope">
          <el-button @click.native.prevent="addRow(scope.$index)" type="text" size="small">新增</el-button>
          <el-button @click.native.prevent="deleteRow(scope.$index)" type="text" size="small">移除</el-button>
        </template>
        </el-table-column>-->
        <el-table-column
          width="180"
          align="center"
          :label="item.Rename"
          :prop="item.Key"
          :key="index"
          v-if="item.Name == '商品名称' && item.Show == true"
          fixed="left"
        >
          <template slot-scope="scope">
            <div class="input_box ub ub-ac">
              <el-input
                size="mini"
                type="text"
                class="input_sty"
                :value="scope.row[item.Key]"
                placeholder
                @dblclick.native="dblClick(scope.$index , tableData)"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="item.Rename"
          :prop="item.Key"
          width="150"
          align="center"
          :key="index"
          v-if="item.Name != '商品名称' && item.Show == true"
        >
          <template slot-scope="scope">
            <div class="input_box ub ub-ac">
              <el-input
                size="mini"
                v-if="scope.row.Name!==''&& scope.row.PtypeId!==''&& scope.row.PStutas!=='赠品'
                 &&(item.Key=='Total'||item.Key=='Discount'||item.Key=='DiscountPrice'||item.Key=='DiscountTotal'||item.Key=='Tax')"
                type="text"
                class="input_sty"
                v-model="scope.row[item.Key]"
                @blur="changeData(scope.row,scope.$index,item.Key)"
                @focus="inputFocus($event)"
                @input="scope.row[item.Key]=scope.row[item.Key].replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g, '$1');"
              ></el-input>

              <el-input
                size="mini"
                v-else-if="scope.row.Name!==''&& scope.row.PtypeId!=='' &&item.Key=='Qty'"
                type="text"
                class="input_sty"
                v-model="scope.row[item.Key]"
                @blur="changeData(scope.row,scope.$index,item.Key)"
                @focus="inputFocus($event)"
                @input="scope.row[item.Key]=scope.row[item.Key].replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g, '$1');"
              ></el-input>

              <el-input
                size="mini"
                v-else-if="scope.row.Name!==''&& scope.row.PtypeId!==''
                 &&(item.Key=='Memo'||item.Key=='BString1'||item.Key=='BString2'||item.Key=='BString3'||item.Key=='BString4'||item.Key=='BString5')"
                type="text"
                class="input_sty"
                v-model="scope.row[item.Key]"
                @blur="changeData(scope.row,scope.$index,item.Key)"
                @focus="inputFocus($event)"
                @input="scope.row[item.Key]"
              ></el-input>
              <el-input
                size="mini"
                v-else-if="scope.row.Name!==''&& scope.row.PtypeId!==''&& scope.row.PStutas!=='赠品'  &&(item.Key=='ShowPrice')"
                type="text"
                class="input_sty"
                v-model="scope.row[item.Key]"
                @blur="changeData(scope.row,scope.$index,item.Key)"
                @focus="inputFocus($event)"
                @dblclick.native.stop="dbClickInp(scope.row,scope.$index,item.Key)"
                @input="scope.row[item.Key]=scope.row[item.Key].replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g, '$1');"
              ></el-input>
              <div
                v-else-if="scope.row.Name!==''&& scope.row.PtypeId!=='' &&item.Key=='PStutas'"
                class="only_show_div"
              >
                <el-select
                  v-model="scope.row[item.Key]"
                  placeholder="请选择"
                  size="mini"
                  @change="selcetChange($event,scope.row,scope.$index)"
                >
                  <el-option label="非赠品" value="非赠品"></el-option>
                  <el-option label="赠品" value="赠品"></el-option>
                </el-select>
              </div>

              <div v-else class="only_show_div">{{scope.row[item.Key]}}</div>

              <i
                class="el-icon-search icon_sty"
                v-if="scope.row.Name!==''&& scope.row.PtypeId!==''&& scope.row.PStutas!=='赠品' &&(item.Key=='ShowPrice')"
                @click="dbClickInp(scope.row,scope.$index,item.Key)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <!-- table表格配置弹出框 -->
    <TableConfigDialog
      :show.sync="tableConfigShow"
      :tableData="ConfigData"
      v-bind="$attrs"
      v-on="$listeners"
      @restoreDefault="restoreDefault"
    />
    <!-- 商品选择弹出框 -->
    <SearchGoodsDialog
      :show.sync="seaechGoodsShow"
      @chooseGoodsBack="chooseGoodsBack"
      v-bind="$attrs"
    />
    <!-- 单位、单价、选择弹出框 -->
    <SearchPriceDialog
      :show.sync="seaechbankShow"
      :searchData="searchData"
      @dbclickRow="chooseGoodsBack"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
import tool from "@/utils/tool";

export default {
  data() {
    return {
      value: false, //是否启用扫码枪录入商品
      tableConfigShow: false, //配置项弹出框是否显示
      seaechGoodsShow: false, //商品选择弹出框是否显示
      seaechbankShow: false, //价格选择弹出框是否显示
      ConfigData: this.tableConfigData, //table配置项数据
      rowIndex: -1, //点击的是第几行
      data: this.tableData, //表格数据项
      // jparam:this.goodsParams,
      searchData: { title: "", data: {}, type: "" } //传递给选择单价与单位的弹出框,title:弹出框标题、data：传过去的数据、type：类型（单价选择、单位选择）
    };
  },
  props: {
    max: String,
    // Namecommodity:String,
    tableData: Array,
    tableConfigData: Array //table配置项数据
    // goodsParams: Object //用于传递给商品弹出框列表
  },
  methods: {
    // 聚焦选中input全部
    inputFocus() {
      event.currentTarget.select();
    },
    rowdblclick(row) {
      // console.log('-----++>',row);
      // this.searchData = {title:'',data:{},type:''}
    },
    // 传递数据给saleorder页面
    chooseGoodsBack(data) {
      // console.log('选价格回传数据',data)
      this.$emit("chooseGoodsBack", data, this.rowIndex);
    },
    // 双击input弹出弹出框
    dbClickInp(data, index, key) {
      // console.log("--->", this.$attrs);
      if (
        this.$attrs.customerVal1.KtypeId == "" ||
        this.$attrs.customerVal1.KtypeId == "undefined"
      ) {
        this.$message({
          message: "请先选择客户或供应商",
          type: "warning"
        });
        return;
      }
      this.rowIndex = index;
      this.searchData = { title: "单价选择", data: data, type: "单价选择" };
      this.seaechbankShow = true;
    },
    //合计方法
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
          return;
        }
        const values = data.map(item => {
          // console.log(column.property);
          if (
            column.property == "Qty" ||
            column.property == "AQty" ||
            column.property == "Total" ||
            column.property == "DiscountTotal" ||
            column.property == "WithTaxTotal"
          ) {
            if (
              item[column.property] != undefined &&
              item[column.property] != ""
            ) {
              return Number(item[column.property]);
            } else {
              return Number(0);
            }
          }
        });
        if (!values.every(value => isNaN(value))) {
          // sums[index] = values.reduce((prev, curr) => {
          //   const value = Number(curr).toFixed(2);
          //   if (!isNaN(value)) {
          //     console.log('--->',Number(prev).toFixed(2),Number(curr).toFixed(2));
          //     return prev + curr;
          //   } else {
          //     return prev;
          //   }
          // }, 0);
          sums[index] = this.sum(values);
          sums[index] += "";
        } else {
          // sums[index] = 'N/A';
        }
      });
      // console.log('///',sums);
      return sums;
    },
    // 移除某一行
    deleteRow(index) {
      this.$emit("deleteRow", index);
    },
    // 新增某一行
    addRow(index) {
      this.$emit("addback", index);
    },
    // 双击列表某一行
    dblClick(index, rows) {
      // console.log(index, rows);
      this.rowIndex = index;
      this.seaechGoodsShow = true;
      // this.$emit('dblClick',index);
    },
    // 数量、单价、金额联动
    changeData(data, index, field) {
      // console.log(data,index,field);
      switch (field) {
        case "Qty":
          if (
            (data.ShowPrice == 0 || data.ShowPrice == "") &&
            (data.Qty != 0 && data.Qty != "")
          ) {
            data.ShowPrice = (Number(data.Total) / Number(data.Qty)).toFixed(2);
          } else {
            data.Total = tool.accMul(
              Number(data.Qty),
              Number(data.ShowPrice),
              2
            );
            // data.Total = Number(data.Qty) * Number(data.ShowPrice);
          }
          data.DiscountPrice = tool.accMul(
            Number(data.Discount),
            Number(data.ShowPrice),
            2
          );
          data.DiscountTotal = tool.accMul(
            Number(data.Discount),
            Number(data.Total),
            2
          );
          // data.DiscountPrice = Number(data.Discount) * Number(data.ShowPrice);//折后单价
          // data.DiscountTotal = Number(data.Discount) * Number(data.Total);//折后金额
          break;
        case "ShowPrice":
          if (
            (data.Qty == 0 || data.Qty == "") &&
            (data.ShowPrice != 0 && data.ShowPrice != "")
          ) {
            data.Qty = (Number(data.Total) / Number(data.ShowPrice)).toFixed(2);
          } else {
            data.Total = tool.accMul(
              Number(data.Qty),
              Number(data.ShowPrice),
              2
            );
            // data.Total = Number(data.Qty) * Number(data.ShowPrice);
          }
          data.DiscountPrice = tool.accMul(
            Number(data.Discount),
            Number(data.ShowPrice),
            2
          );
          data.DiscountTotal = tool.accMul(
            Number(data.Discount),
            Number(data.Total),
            2
          );
          // data.DiscountPrice = Number(data.Discount) * Number(data.ShowPrice);//折后单价
          // data.DiscountTotal = Number(data.Discount) * Number(data.Total);//折后金额
          break;
        case "Total":
          if (
            (data.Qty == 0 || data.Qty == "") &&
            (data.ShowPrice != 0 && data.ShowPrice != "")
          ) {
            data.Qty = (Number(data.Total) / Number(data.ShowPrice)).toFixed(2);
          }
          if (data.Qty != 0 && data.Qty != "") {
            data.ShowPrice = (Number(data.Total) / Number(data.Qty)).toFixed(2);
          }
          data.DiscountPrice = tool.accMul(
            Number(data.Discount),
            Number(data.ShowPrice),
            2
          );
          data.DiscountTotal = tool.accMul(
            Number(data.Discount),
            Number(data.Total),
            2
          );
          // data.DiscountPrice = Number(data.Discount) * Number(data.ShowPrice);//折后单价
          // data.DiscountTotal = Number(data.Discount) * Number(data.Total);//折后金额
          break;
        // 折扣
        case "Discount":
          data.DiscountPrice = tool.accMul(
            Number(data.Discount),
            Number(data.ShowPrice),
            2
          );
          data.DiscountTotal = tool.accMul(
            Number(data.Discount),
            Number(data.Total),
            2
          );
          // data.DiscountPrice = Number(data.Discount) * Number(data.ShowPrice);//折后单价
          // data.DiscountTotal = Number(data.Discount) * Number(data.Total);//折后金额
          break;
        // 折扣单价
        case "DiscountPrice":
          if (data.ShowPrice != 0 && data.ShowPrice != "") {
            data.Discount = (
              Number(data.DiscountPrice) / Number(data.ShowPrice)
            ).toFixed(2); //折后单价
            data.DiscountTotal = tool.accMul(
              Number(data.Discount),
              Number(data.Total),
              2
            );
            // data.DiscountTotal = Number(data.Discount) * Number(data.Total);//折后金额
          } else {
            this.$message({
              message: "单价不能为0或空",
              type: "warning"
            });
            data.Discount = 0;
            data.DiscountPrice = tool.accMul(
              Number(data.Discount),
              Number(data.ShowPrice),
              2
            );
            data.DiscountTotal = tool.accMul(
              Number(data.Discount),
              Number(data.Total),
              2
            );
          }
          break;
        // 折扣金额
        case "DiscountTotal":
          if (data.Total != 0 && data.Total != "") {
            data.Discount = (
              Number(data.DiscountTotal) / Number(data.Total)
            ).toFixed(2); //计算折扣
            data.DiscountPrice = tool.accMul(
              Number(data.Discount),
              Number(data.ShowPrice),
              2
            ); //计算折扣单价
            data.DiscountTotal = tool.accMul(
              Number(data.Discount),
              Number(data.Total),
              2
            ); //计算折扣金额
          } else {
            this.$message({
              message: "金额不能为0或空",
              type: "warning"
            });
            data.Discount = 0;
            data.DiscountPrice = tool.accMul(
              Number(data.Discount),
              Number(data.ShowPrice),
              2
            );
            data.DiscountTotal = tool.accMul(
              Number(data.Discount),
              Number(data.Total),
              2
            );
          }
          break;
        default:
          break;
      }
      // data.DiscountPrice = Number(data.Discount) * Number(data.ShowPrice);//折后单价
      // data.DiscountTotal = Number(data.Discount) * Number(data.Total);//折后金额
      data.TaxTotal = tool.accMul(Number(data.Tax), Number(data.Total), 2); //税额
      data.TaxPrice = tool.accMul(
        Number(data.Tax) + 1,
        Number(data.ShowPrice),
        2
      ); //产品含税单价
      data.WithTaxTotal = tool.accMul(
        Number(data.Tax) + 1,
        Number(data.Total),
        2
      );
      // 零售金额
      data.SaleTotal = tool.accMul(Number(data.SalePrice), Number(data.Qty), 2);
      // data.TaxTotal = Number(data.Tax) * Number(data.Total);//税额
      // data.TaxPrice = (Number(data.Tax)+1) * Number(data.ShowPrice);//产品含税单价
      // data.WithTaxTotal = (Number(data.Tax)+1) * Number(data.Total);//产品含税金额
      // this.$emit('changeiput',data,index);
    },
    //点击图标事件
    clickIcon() {
      this.tableConfigShow = true;
      // this.$emit('clickIcon')
    },
    // 累加数组中的number
    sum(arr) {
      var s = 0;
      for (var i = arr.length - 1; i >= 0; i--) {
        s += arr[i];
      }
      return Number(s).toFixed(2);
    },
    // 恢复默认回调数据
    restoreDefault(data) {
      // console.log('====>',data)
      this.ConfigData = data;
    },
    //
    selcetChange(val, data, index) {
      // console.log('选择框数据',val,data,index);
      // data.Qty = 0;//数量
      data.ShowPrice = 0; //单价
      data.Total = 0; //金额
      data.Tax = 0; //税率
      data.TaxPrice = 0; //含税单价
      data.WithTaxTotal = 0; //含税金额
      data.TaxTotal = 0; //税额
      data.Discount = 1; //折扣
      data.DiscountPrice = 0; //折扣单价
      data.DiscountTotal = 0; //折扣金额
      data.SaleTotal = 0; //零售金额
    }
  },
  watch: {
    tableConfigData: {
      handler(newValue, oldValue) {
        this.ConfigData = newValue;
        this.data = this.tableData;
      },
      deep: true,
      immediate: true
    },
    tableData: {
      handler(newValue, oldValue) {
        // console.log('tableData数据以改变');
        this.data = this.tableData;
      },
      deep: true
    }
  },
  computed: {},
  mounted() {
    // console.log(this.tableConfigData);
  }
};
</script>
<style lang="less">
// 引入样式
@import "./Table.less";
</style>


// WEBPACK FOOTER //
// src/components/Table/Table/Table.vue